import React from "react";
import "./Education.scss";
import EducationCard from "../../components/educationCard/EducationCard";
import {educationInfo} from "../../portfolio";
import Reveal from "../../components/reveal/Reveal";

export default function Education() {
  if (!educationInfo.display) {
    return null;
  }
  return (
    <div className="main education-section" id="education">
      <Reveal direction="up">
        <div className="education-content reveal-stagger">
          <header className="education-header" style={{"--i": 0}}>
            <span className="section-eyebrow">Background</span>
            <h1 className="section-heading">Education</h1>
            <p className="section-subtitle">
              Academic foundation behind the work I ship
            </p>
          </header>
          <div className="education-card-container" style={{"--i": 1}}>
            {educationInfo.schools.map((school, index) => (
              <EducationCard key={index} school={school} />
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  );
}
